import { makeAutoObservable } from 'mobx';
import * as PIXI from 'pixi.js';
import type { IPixiManagerModel } from '@/interfaces/models';

import randomSvg from '#/random.svg';
import clockSvg from '#/time.svg';
import multiplySvg from '#/cross.svg';

export enum TextureKey {
  Random = 'Random',
  Clock = 'Clock',
  Multiply = 'Multiply',
}

export const TextureMap: Record<TextureKey, string> = {
  [TextureKey.Random]: randomSvg,
  [TextureKey.Clock]: clockSvg,
  [TextureKey.Multiply]: multiplySvg,
};

export class PixiManagerModel implements IPixiManagerModel {
  textures: Partial<Record<TextureKey, PIXI.Texture>> = {};

  constructor() {
    makeAutoObservable(this, {}, { autoBind: true });
  }

  async load(): Promise<void> {
    await Promise.all(Object.entries(TextureMap).map(async ([key, location]) => {
      this.textures[key as TextureKey] = await PIXI.Assets.load<PIXI.Texture>(location);
    }));
  }
}
